import { api } from './authService';

export const favoritesService = {
    saveMessage: (messageId) => api.post(`/favorites/save/${messageId}`),
    unsaveMessage: (messageId) => api.delete(`/favorites/unsave/${messageId}`),
    getFavoriteMessages: async () => {
        const response = await api.get('/favorites');
        return response.data;
    },
    getFavoriteChannel: async () => {
        const response = await  api.get('/favorites/channel');
        return response.data;
    },
};